"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _ui = require("@unite-us/ui");
var _reactIntl = require("react-intl");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var acceptanceInfo = {
  accept: {
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "rIbqjm",
      description: "Accepting",
      defaultMessage: "Accepting referrals"
    }),
    icon: /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
      icon: "IconCheckCircle",
      color: "#117E15",
      className: "mr-quarter"
    })
  },
  deny: {
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "l8K7Nm",
      description: "not-accepting",
      defaultMessage: "Not accepting referrals"
    }),
    icon: /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
      icon: "IconTimesCircle",
      color: "#CF2A2A",
      className: "mr-quarter"
    })
  },
  deactivate: {
    text: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
      id: "QZHz8u",
      description: "deactivated",
      defaultMessage: "Deactivated"
    }),
    icon: /*#__PURE__*/_react["default"].createElement(_ui.Icon, {
      icon: "IconMinusCircle",
      size: 13.7,
      color: "#CF2A2A",
      className: "mr-quarter"
    })
  }
};
function ProgramAcceptance(props) {
  var receiving_referrals = props.receiving_referrals,
    status = props.status,
    hide_referrals = props.hide_referrals,
    is_active = props.is_active;
  if (hide_referrals && !is_active) {
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: "program-acceptance mt-half"
    }, acceptanceInfo.deactivate.icon, /*#__PURE__*/_react["default"].createElement("p", null, acceptanceInfo.deactivate.text));
  }
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "program-acceptance mt-half"
  }, receiving_referrals ? acceptanceInfo.accept.icon : acceptanceInfo.deny.icon, receiving_referrals ? /*#__PURE__*/_react["default"].createElement("p", null, acceptanceInfo.accept.text) : /*#__PURE__*/_react["default"].createElement("p", null, acceptanceInfo.deny.text, " ", status && "(".concat(status, ")")));
}
ProgramAcceptance.propTypes = {
  receiving_referrals: _propTypes["default"].bool.isRequired,
  status: _propTypes["default"].string,
  hide_referrals: _propTypes["default"].bool,
  is_active: _propTypes["default"].bool
};
ProgramAcceptance.defaultProps = {
  status: '',
  hide_referrals: false,
  is_active: false
};
var _default = exports["default"] = ProgramAcceptance;